// extracted by mini-css-extract-plugin
module.exports = {"textBlock":"pages-module--text-block--3v6Rt","darkHeader":"pages-module--dark-header--16bk1","spacer":"pages-module--spacer--3zAEt","bar":"pages-module--bar--2CpVs"};